import * as React from 'react';
import { SVGProps } from 'react';

const SvgXlsx = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg width={25} height={32} viewBox="0 0 25 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
    <rect width={24} height={32} rx={3} fill="#C3E2D8" />
    <rect x={5} y={17} width={20} height={10} rx={1} fill="#278E6C" />
    <path
      d="m6.8 25.201 2.017-3.195v-.013L6.813 18.86h1.56l1.35 2.285h.048l1.34-2.285h1.481l-2.079 3.155v.018l2.053 3.168h-1.512L9.66 22.977h-.044l-1.384 2.224H6.8ZM13.308 25.201V18.86h1.327v5.247h2.773V25.2h-4.1ZM20.51 25.311c-1.506 0-2.478-.69-2.552-1.859l-.005-.07h1.253l.009.048c.083.492.606.8 1.331.8.734 0 1.195-.32 1.195-.804v-.005c0-.43-.312-.646-1.098-.808l-.668-.132c-1.253-.25-1.886-.848-1.886-1.802v-.004c0-1.16 1.011-1.925 2.418-1.925 1.467 0 2.368.734 2.43 1.846l.004.083H21.69l-.005-.052c-.066-.497-.523-.8-1.178-.8-.68.004-1.09.316-1.09.769v.004c0 .4.326.633 1.055.778l.673.136c1.327.264 1.925.804 1.925 1.802v.004c0 1.218-.959 1.991-2.558 1.991Z"
      fill="#fff"
    />
  </svg>
);

export default SvgXlsx;
